<template>
  <social-link :href="link" target="_blank" :fillcolor="color">
    <div class="wrapper">
      <svg viewBox="0 0 32 32" width="32" height="32"><title>logo fb simple</title><g :fill="color"><path :fill="color" d="M12.46218,31V18H8v-6h4.46218V7.80998C12.46218,3.24577,15.35166,1,19.42325,1 c1.95033,0,3.62655,0.1452,4.11504,0.21011v4.76987l-2.82387,0.00128C18.50007,5.98127,18,7.0335,18,8.57757V12h6l-2,6h-4v13 H12.46218z"></path></g></svg>
    </div>
  </social-link>
</template>

<script>
import { SocialLink } from '@/styles/components'

export default {
  components: {
    SocialLink
  },
  props: [
    'link',
    'color'
  ]
}
</script>
